<template>
    <v-dialog :value="active" max-width="760px" content-class="round" persistent>
        <v-card>
            <v-card-title>
                <Title class="ma-2" text="Editar presentación"></Title>
            </v-card-title>

            <v-card-text class="pb-0">
                <p>
                    Pega el enlace de la presentación de la charla. Es el que abre
                    el botón del panel de informaciones, también a quien todavía no
                    inició sesión. Tiene que estar compartida en Google Drive,
                    Google Docs o OneDrive.
                </p>

                <v-text-field
                    v-model="url"
                    label="Enlace de la presentación"
                    placeholder="https://drive.google.com/file/d/..."
                    rounded
                    filled
                    :error-messages="errores"
                    @input="errores = []"
                ></v-text-field>

                <p v-if="enlaceValido" class="text-center mb-2">
                    <a :href="url" target="_blank" rel="noopener noreferrer">
                        Abrir la presentación para comprobar el enlace
                    </a>
                </p>
                <p v-else-if="url" class="text-center font-italic mb-2">
                    El enlace tiene que ser de Google Drive, Google Docs o OneDrive.
                </p>
            </v-card-text>

            <v-card-actions>
                <BottomArrowsStep
                    :withoutIcons="true"
                    nextText="Guardar"
                    backText="Cancelar"
                    :backAction="cerrar"
                    :nextAction="guardar"
                    :nextDisabled="!enlaceValido || guardando"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Title from "@/components/forms/Title";
import BottomArrowsStep from "@/components/forms/BottomArrowsStep";
import { tablesService } from "@/services";
import { esEnlaceDeDocumento } from "@/helpers/documento";

// La clave con la que el backend guarda este enlace. El frontend pide el
// recurso por su clave y no por id, así no depende de ningún número.
const CLAVE = "presentacion_charla";

// Se usa `tablesService` y no la acción `tables/edit` del store por lo mismo que
// en ModalVideo: esa acción no devuelve el cuerpo de la respuesta ni propaga el
// error, y aquí hacen falta los dos —la URL que quedó guardada y el mensaje de
// validación cuando el enlace no es de un servicio aceptado.

export default {
    components: { Title, BottomArrowsStep },

    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        url: "",
        errores: [],
        guardando: false,
    }),

    computed: {
        // Solo habilita el botón y ofrece el enlace de prueba. Quien decide qué
        // se guarda es el backend, que valida el host por su cuenta.
        enlaceValido() {
            return esEnlaceDeDocumento(this.url);
        },
    },

    watch: {
        active(abierto) {
            if (abierto) {
                this.cargar();
            }
        },
    },

    created() {
        if (this.active) {
            this.cargar();
        }
    },

    methods: {
        cargar() {
            this.errores = [];
            tablesService
                .getService(`recursoinfoproceso/${CLAVE}`)
                .then((recurso) => {
                    this.url = recurso.url;
                })
                .catch(() => {
                    this.errores = ["No se pudo cargar el enlace actual."];
                });
        },

        guardar() {
            this.guardando = true;
            tablesService
                .editService("recursoinfoproceso", `${CLAVE}/`, { url: this.url })
                .then((recurso) => {
                    this.guardando = false;
                    // Se adopta la URL que devuelve el backend para que el campo
                    // muestre exactamente lo guardado.
                    this.url = recurso.url;
                    this.$store.dispatch(
                        "alert/success",
                        "Presentación actualizada."
                    );
                    this.$emit("guardado", recurso.url);
                    this.$emit("cerrar");
                })
                .catch((error) => {
                    this.guardando = false;
                    this.errores = this.mensajesDeError(error);
                });
        },

        mensajesDeError(error) {
            const datos = error && error.response && error.response.data;
            if (datos && datos.url) {
                return Array.isArray(datos.url) ? datos.url : [datos.url];
            }
            return ["No se pudo guardar el enlace."];
        },

        cerrar() {
            this.errores = [];
            this.$emit("cerrar");
        },
    },
};
</script>
